import { render, staticRenderFns } from "./Loading.vue?vue&type=template&id=2955529b&scoped=true"
import script from "./Loading.vue?vue&type=script&lang=js"
export * from "./Loading.vue?vue&type=script&lang=js"
import style0 from "./Loading.vue?vue&type=style&index=0&id=2955529b&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2955529b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/html/untrrv2/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2955529b')) {
      api.createRecord('2955529b', component.options)
    } else {
      api.reload('2955529b', component.options)
    }
    module.hot.accept("./Loading.vue?vue&type=template&id=2955529b&scoped=true", function () {
      api.rerender('2955529b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/miscellaneous/Loading.vue"
export default component.exports